import {
    CANCEL_BOOKING_START,
    CANCEL_BOOKING_SUCCESS,
    CANCEL_BOOKING_ERROR
} from "../../constants/index";
import { cancelManualBooking as mutation } from "../../lib/graphql";
import { setLoaderStart, setLoaderComplete } from "../loader/loader";
import showToaster from "../../helpers/toastrMessgaes/showToaster";
import { closeHeaderModal } from "../siteadmin/modalActions";

export function cancelBookingAction({ bookingId, reason }) {

    return async (dispatch, getState, { client }) => {
        try {

            dispatch({
                type: CANCEL_BOOKING_START,
            });

            dispatch(setLoaderStart('cancelBooking'));

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId: Number(bookingId),
                    reason
                },
            });
            if (data?.cancelManualBooking?.status === 200) {
                dispatch(setLoaderComplete('cancelBooking'));

                dispatch({
                    type: CANCEL_BOOKING_SUCCESS,
                });
                window.location.replace('/bookings/previous');
                dispatch(closeHeaderModal('cancelReasonForm'));
            } else {
                dispatch(setLoaderComplete('cancelBooking'));
                dispatch({
                    type: CANCEL_BOOKING_ERROR,
                    payload: {
                        error: data?.cancelManualBooking?.errorMessage,
                    },
                });
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: data?.cancelManualBooking?.errorMessage })
            }
        } catch (error) {
            dispatch({
                type: CANCEL_BOOKING_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}
